import { useState } from 'react';
import { Modal, ShowDate } from 'framework/ui/ui-builder';
import { Button } from 'framework/ui/mui-builder';
import { DATE_FORMAT } from 'framework/utils';

interface EarlyStartedHandlerProps {
  nextReviewDate: string;
  isEarlyStarted: boolean;
}

const EarlyStartedHandler = ({ nextReviewDate, isEarlyStarted }: EarlyStartedHandlerProps) => {
  const [isOpen, setIsOpen] = useState(true);

  const closeModal = () => {
    setIsOpen(false);
  };

  const continueButton = (
    <Button
      onClick={() => {
        closeModal();
      }}
      key="btn-success"
    >
      Continue
    </Button>
  );

  return isEarlyStarted ? (
    <Modal
      isOpen={isOpen}
      title="Business rules violated"
      buttons={[continueButton]}
      onToggle={() => closeModal()}
      key="modal-not-strict"
      hasCancelButton={false}
    >
      <p>
        Your next career review date is defined as{' '}
        <ShowDate dateUTC={nextReviewDate} format={DATE_FORMAT.NATURAL} isDateTime={false} />. In a normal case, you
        should request your career review not earlier than this date.
      </p>
      <p>
        If you want the review to be started earlier, please provide the reasons for the early process start in the
        corresponding field and submit the request. A task will be assigned to your people manager to approve the
        violation.
      </p>
    </Modal>
  ) : null;
};

export default EarlyStartedHandler;
